import { useDispatch, useSelector } from 'react-redux';
import { getConsignmentOrderRefundById } from '../../../../appRedux/actions';
import { useEffect } from 'react';
import { Col, Row, Table } from 'antd';
import { consignmentOrderRefundModalConst } from '../../../../constants/ConsignOrderRefund.const';
import { ConsignOrderRefundStatus } from '../ConsignmentOrderRefundStatus';
import { formatPrice } from '../../../../util/formatPrice';
import { stringDate } from '../../../../util';

export const ConsignOrderRefundModalBody = ({ data = {} }) => {
  const dispatch = useDispatch();

  const { consignmentOrderRefundById } = useSelector(
    (state) => state.consignmentOrderRefund
  );

  useEffect(() => {
    if (data.id) {
      dispatch(getConsignmentOrderRefundById(data.id));
    }
  }, [data.id, dispatch]);

  const tableData =
    consignmentOrderRefundById?.consignmentOrderRefundProduct?.map(
      (item, index) => ({
        key: item.id || index,
        productName:
          item.consignmentOrderProduct?.product?.name ??
          consignmentOrderRefundModalConst.noData,
        received: item.consignmentOrderProduct?.quantity ?? 0,
        refunded: item.quantity ?? 0,
      })
    ) || [];

  const columns = [
    {
      title: 'Producto',
      dataIndex: 'productName',
      key: 'productName',
    },
    {
      title: 'Total recibido',
      dataIndex: 'received',
      key: 'received',
      align: 'right',
    },
    {
      title: 'Total devuelto',
      dataIndex: 'refunded',
      key: 'refunded',
      align: 'right',
    },
  ];

  return (
    <>
      <Row className="row">
        <Col span={8}>
          <h4>{consignmentOrderRefundModalConst.refundAt}</h4>
        </Col>
        <Col span={16}>
          {consignmentOrderRefundById?.refundAt
            ? stringDate(consignmentOrderRefundById.refundAt)
            : consignmentOrderRefundModalConst.noData}
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{consignmentOrderRefundModalConst.status}</h4>
        </Col>
        <Col span={16}>
          <ConsignOrderRefundStatus
            status={consignmentOrderRefundById?.status}
          />
        </Col>
      </Row>

      <Row className="row">
        <Col span={8}>
          <h4>{consignmentOrderRefundModalConst.total}</h4>
        </Col>
        <Col span={16}>{formatPrice(consignmentOrderRefundById?.total)}</Col>
      </Row>

      <br />

      <Table
        columns={columns}
        dataSource={tableData}
        rowKey="id"
        pagination={{
          defaultPageSize: 10,
          pageSizeOptions: [10, 20, 40, 60],
        }}
      />
    </>
  );
};
